import { Injectable } from '@angular/core';
import { BaseService } from "../base/base.service";
import { ContentFactory, ContentList } from '../../squidex';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TemplateService extends BaseService {

  constructor(contentFactory: ContentFactory) {

    super('template', contentFactory);
  }


  getByCategory(category: string): Observable<ContentList> {
    this.initialize();
    return this.contentService
      .findContent(`?$filter=data/deleted/iv ne true and data/category/iv eq '${category}'`);
  }
}
